import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';

import ApiKeyTable from './Table';
import ApiKeyView from './View';
import ApiKeyStatistic from './Statistic';

/* eslint-disable prettier/prettier */
const routes = [
  { path: '', component: ApiKeyTable, exact: true },
  { path: 'new', component: ApiKeyView, exact: true },
  { path: ':id', component: ApiKeyView, exact: true },
  { path: 'statistic/:id', component: ApiKeyStatistic, exact: true },
];
/* eslint-enable prettier/prettier */

class ApiKey extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.ADMIN])(ApiKey);
